import {Observable} from 'rxjs';
import {List} from 'immutable';
import i18next from 'i18next';

import {combineEpics} from 'web-app/util/redux-observable';
import * as Api from 'web-app/react/entities/bill-payers/api';
import {createOrUpdateObservable} from 'web-app/react/entities/bill-payers/epics';
import {createPaymentObservable, deletePaymentObservable} from 'web-app/react/entities/recurring-payments/epics';
import {showDeleteDialogObservable, DialogChoice} from 'web-app/react/dialog';
import * as AccountItemActions from 'web-app/react/entities/account-items/actions';
import * as ChildActions from 'web-app/react/entities/children/actions';

import * as Actions from './actions';
import * as Constants from './constants';

const searchForBillPayer = action$ =>
    action$
        .ofType(Actions.search.type)
        .debounceTime(500)
        .mergeMap(({payload}) =>
            Api.searchBillPayer(payload.institutionId, null, payload.term, Constants.billPayerTypeCompany)
                .flatMap(({billPayers, children}) => [
                    ChildActions.fetchAllSuccess.action(children),
                    Actions.searchSuccess.action({billPayers}),
                ])
                .catch(e => Observable.of(Actions.searchFailed.action(e))),
        );

const save = action$ =>
    action$
        .ofType(Actions.save.type)
        .debounceTime(500)
        .mergeMap(({payload}) => {
            if (payload.voucherCompany.billPayerId) {
                return createPaymentObservable(payload.institutionId, payload.billPayerId, {
                    ...payload.payment,
                    voucherCompany: {
                        voucherCompanyId: payload.voucherCompany.billPayerId,
                    },
                })
                    .flatMap(paymentSuccess =>
                        List([
                            paymentSuccess,
                            AccountItemActions.fetchBillPayerBalance.action(payload.institutionId, payload.billPayerId),
                            Actions.saveSuccess.action(),
                        ]),
                    )
                    .catch(e => Observable.of(Actions.saveFailed.action(e)));
            }
            return createOrUpdateObservable(payload.institutionId, null, payload.voucherCompany)
                .flatMap(billPayerSuccess => {
                    return createPaymentObservable(payload.institutionId, payload.billPayerId, {
                        ...payload.payment,
                        voucherCompany: {
                            voucherCompanyId: billPayerSuccess.payload.billPayer.billPayerId,
                        },
                    }).flatMap(paymentSuccess =>
                        List([
                            billPayerSuccess,
                            paymentSuccess,
                            AccountItemActions.fetchBillPayerBalance.action(payload.institutionId, payload.billPayerId),
                            Actions.saveSuccess.action(),
                        ]),
                    );
                })
                .catch(e => Observable.of(Actions.saveFailed.action(e)));
        });

const deletePayment = action$ =>
    action$.ofType(Actions.deletePayment.type).mergeMap(({payload}) => {
        return showDeleteDialogObservable({
            title: '',
            description: i18next.t('vouchers.confirmVoucherDelete'),
        }).mergeMap(selection => {
            if (selection === DialogChoice.OK) {
                return deletePaymentObservable(payload.institutionId, payload.billPayerId, payload.recurringPaymentId)
                    .flatMap(deleteSuccess =>
                        List([
                            Actions.deletePaymentSuccess.action(),
                            deleteSuccess,
                            AccountItemActions.fetchBillPayerBalance.action(payload.institutionId, payload.billPayerId),
                        ]),
                    )
                    .catch(e => Observable.of(Actions.deletePaymentFailed.action(e)));
            } else {
                return Observable.of(Actions.deletePaymentAborted.action());
            }
        });
    });

export default combineEpics(deletePayment, searchForBillPayer, save);
